import React, { useEffect, useState } from 'react'
import HttpClient from '../../../services/HttpClient'
import TerritoryFilters from '../../../components/TerritoryFilters/TerritoryFilters'
import TerritoryGrid from '../../../components/TerritoryGrid/TerritoryGrid'
import './TerritoriesIndex.css'

export default function TerritoriesIndex() {
  const [territories, setTerritories] = useState([])
  const [filteredTerritories, setFilteredTerritories] = useState([])
  const [filterStats, setFilterStats] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    document.title = "Shinobis' War :: Territorios"
    loadTerritories()
  }, [])

  const loadTerritories = async () => {
    setLoading(true)
    setError(null)
    try {
      const { data } = await HttpClient().get('/api/v1/stats/territories-with-stats')
      const list = Array.isArray(data) ? data : []
      setTerritories(list)
      setFilteredTerritories(list)
    } catch (err) {
      console.error('Error fetching territories with stats:', err)
      try {
        const { data } = await HttpClient().get('/api/v1/territory')
        const list = Array.isArray(data) ? data : []
        setTerritories(list)
        setFilteredTerritories(list)
      } catch (fallbackError) {
        console.error('Error fetching territories:', fallbackError)
        setError('No se pudieron cargar los territorios.')
        setTerritories([])
        setFilteredTerritories([])
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <main className="territories-index" role="main" aria-label="Índice de Territorios">
      <header className="territories-header">
        <span className="territories-header__eyebrow">地 · Explorar</span>
        <h1 className="territories-title">Tierras conocidas</h1>
        <p className="territories-subtitle">Explora los Hans y las crónicas que laten en su interior</p>
        {filterStats && territories.length > 0 && (
          <p className="territories-meta">
            Mostrando {filterStats.totalResults} de {territories.length} territorios
            {filterStats.searchTerm ? ` · Búsqueda: "${filterStats.searchTerm}"` : ''}
          </p>
        )}
      </header>

      <section className="territories-section">
        {loading && <p className="territories-empty">Consultando el atlas…</p>}
        {error && !loading && <p className="territories-empty">{error}</p>}
        {!loading && !error && territories.length === 0 && (
          <p className="territories-empty">Aún no hay territorios registrados.</p>
        )}
        {!loading && !error && territories.length > 0 && (
          <>
            <TerritoryFilters
              territories={territories}
              onFilteredTerritories={setFilteredTerritories}
              onFiltersChange={setFilterStats}
            />
            {filteredTerritories.length > 0 ? (
              <TerritoryGrid territories={filteredTerritories} />
            ) : (
              <p className="territories-empty">No hay territorios que coincidan con los filtros.</p>
            )}
          </>
        )}
      </section>
    </main>
  )
}
